import React from 'react';
import numeral from 'numeral';

import SPUtilities from '../util/SPUtilities';
import RespUtils from '../util/RespUtils';

import SPCalc from '../util/SPCalc';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import constants from "../constants";
import StakeFormatter from '../components/StakeFormatter';
import AddressUtils from '../util/AddressUtils';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import LogoUtils from '../util/LogoUtils';

class MainUtils extends React.Component {

  static calcPercent(input1, input2) {
    // console.info("getStakeWeight - ", poolStake, totalStake);
    if (input2 === undefined || input2 === 0) {
      return "";
    }

    if (input1 === undefined || input1 === 0) {
      return 0;
    }

    return MainUtils.getPercentValue(input1, input2) + "%";
  }

  static getPercentValue(input1, input2) {
    // console.info("getStakeWeight - ", poolStake, totalStake);
    if (input2 === undefined || input2 === 0) {
      return "";
    }

    if (input1 === undefined || input1 === 0) {
      return 0;
    }

    return (input1 * 100 /input2).toFixed(2);
  }


  static websiteLink(label, link) {
    if (!label) {
      return label;
    }

    if (!link) {
      return label;
    }

    return (<a className="animLink" target="_blank"
      href={SPUtilities.getUrl(link)}>{label}</a>);
  }

  static websiteFormatterTable(cell, row) {
    if (!cell) {
      return cell;
    }

    return (<a className="animLinkTable" target="_blank"
      href={SPUtilities.getUrl(cell)}>{cell}</a>);
  }

  static websiteFormatter(cell, row) {
    if (!cell) {
      return cell;
    }

    return (<a className="animLink" target="_blank"
      href={SPUtilities.getUrl(cell)}>{cell}</a>);
  }

  static addressFormatter(cell, row, index, formatExtraData) {
    return MainUtils.addressFormatterByType(cell, true, true);
  }

  static addressFormatterDel(cell, row, index, formatExtraData) {
    return MainUtils.addressFormatterByType(cell, false, false);
  }

  static valAddressFormatterLong(address) {
    return MainUtils.addressFormatterByType(address, false, true);
  }

  static addressFormatterByType(address, short, validator) {
    if (!address) {
      return "";
    }

    let label = SPUtilities.addressLabelShortFormatter(address, null, short);
    let link = "/address/";
    let target = "";
    if(validator && validator === true) {
      target = "_blank";
      link = constants.urls.stakingHomeForValidator;
    }

    
    return (<span><a className="animLink" target={target}
      href={link + address}>{label}</a>
      &nbsp;{MainUtils.copyLink(address)}</span>);
  }

  static addressFormatterByLabel(cell, row) {
    return MainUtils.addressFormatterLabelShortInd(cell, row, false);
  }

  static addressFormatterByLabelShort(cell, row) {
    return MainUtils.addressFormatterLabelShortInd(cell, row, true);
  }

  static addressFormatterLabelShortInd(cell, row, short) {
    if (!cell) {
      return "";
    }

    let shortInd = short;
    if (!shortInd) {
      shortInd = (window.innerWidth > 1000 ? false : true);
    }

    let label = row.alias;
    if (!row.alias) {
      label = SPUtilities.addressLabelShortFormatter(cell, null, shortInd);
    }

    let link = "/address/";

    return (<span><a className="black-a"
      href={link + row.address}>{label}</a>
      &nbsp;{AddressUtils.copyLink(row.address)}</span>);
  }

  static getNameLabel(cell) {
    let length = RespUtils.isMobileView() ? 12 : 40;

    return MainUtils.getShortText(cell, length);
  }

  static getNameLabelShorter(cell) {
    let length = RespUtils.isMobileView() ? 12 : 30;

    return MainUtils.getShortText(cell, length);
  }

  static nameFormatterNoLink(cell) {
    if (!cell) {
      return "";
    }

    let label = cell.split("?").join("");
    return label;
    // return MainUtils.getNameLabel(cell);
  }

  static nameFormatterNoLinkLimitSize(cell) {
    if (!cell) {
      return "";
    }

    let label = cell.split("?").join("");
    if (RespUtils.isTabletView() && label !== null && label.length > 15) {
      label = label.substring(0, 15) + "...";
    }

    return label;
    // return MainUtils.getNameLabel(cell);
  }

  static nameFormatterTableWithLogo(cell, row) {
    if (!cell) {
      return "";
    }

    let label = MainUtils.getNameLabelShorter(cell);

    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a className="tourValName animLinkTable"
      href={"/relayer/" + row.identity}>{LogoUtils.formatLogoByPathAndSizeAndStyle(
      row.logoPath, row, "logoStyleWithName")}&nbsp;&nbsp;{label}</a></span>);
  }

  static nameFormatterTable(cell, row) {
    if (!cell) {
      return "";
    }

    let label = MainUtils.getNameLabel(cell);

    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a className="tourValName animLinkTable"
      href={"/val/" + row.operatorAddress}>{label}</a>{MainUtils.renderNewValidatorBadge(row)}</span>);
  }

  static nameFormatter(cell, row) {
    if (!cell) {
      return "";
    }

    let label = MainUtils.getNameLabel(cell);

    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a className="animLinkTable"
      href={"/val/" + row.operatorAddress}>{label}</a></span>);
  }

  static nameFormatterShort(cell, row) {
    if (!cell) {
      return "";
    }

    let label = cell.split("?").join("");

    if (window.innerWidth < 1000 && label.length > 8) {
      label = label.substring(0, 6) + ".";
    }

    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a className="black-a" href={"/val/" + row.poolId}
      >{label}</a></span>);
  }

  static nameFormatterLong(cell, row) {
    if (!cell) {
      return "";
    }

    let label = cell.split("?").join("");

    return (<span><a className="animLinkTable" href={row.website} target="_blank"
      >{label}</a></span>);
  }

  static replaceAll(value, search, replace) {
    return value.split(search).join(replace);
  }

  static copyLink(address) {
    let imgSrc = "/images/copy.png";
    let title = "Copy address to clipboard"
    return (<CopyToClipboard text={address}
        onCopy={() => {
          // formatExtraData.setState({copied: row.address});
          // console.log(row.address);
          // return false;
        }}>
        <img src={imgSrc} title={title}
          className="imgicon" width={16} height={16} />
      </CopyToClipboard>)

    // return (<CopyAddress address={address} />)
  }

  static addressLabelShortFormatter(value, row, short) {
    if (!value) {
      return value;
    }

    let label = value;
    if (short || (window.innerWidth < 1400 && value.length > 10)) {
      if (window.innerWidth < 600) {
        label = value.substring(0,6) + "..";
      } else {
        label = value.substring(0,10) + "..";
      }
    }

    return label;
  }

  static eriFormatter(cell, row, index, extra) {
    if (row.status === 'Elected' && !cell) {
      return "N/A";
    }

    let color = "green";

    if (!cell || cell < 0.8) {
      color = "red";
    } else if (cell > 0.95) {
      color = "green";
    } else {
      color = "orange";
    }

    return MainUtils.colorFormatter(cell, color);
  }

  static signPerFormatter(cell, row, index, extra) {
    let color = "orange";

    if (!cell || cell < 80) {
      color = "red";
    } else if (cell > 95) {
      color = "green";
    }

    return <a class="regular-b-a" href={"/keys/" + row.poolId}>{MainUtils.colorFormatter(cell, color)}</a>;
  }

  static calcSignPerAndFormat(lifetimeSigned, lifetimeToSign, poolId) {
    let cell = MainUtils.getPercentValue(lifetimeSigned, lifetimeToSign);
    let color = "orange";

    if (!cell || cell < 90) {
      color = "red";
    } else if (cell > 99) {
      color = "green";
    }

    return <a class="regular-b-a" href={"/keys/" + poolId}>{MainUtils.colorFormatter(cell + "%", color)}</a>;
  }

  static signPerFormatterTitle(cell, row, index, extra) {
    return cell;
  }

  static keySignPerFormatter(cell, row, index, extra) {
    let color = "green";

    if (!cell || cell < 0.97) {
      color = "red";
    } else if (cell > 0.98) {
      color = "green";
    } else {
      color = "orange";
    }

    return MainUtils.colorFormatter(cell, color);
  }

  static statusFormatter(cell, row, index, extra) {
    // let color = "green";

    // if (!cell || cell !== 'Bonded') {
    //   color = "red";
    // }

    let value = cell;
    if (RespUtils.isMobileView()) {
      value = value.substring(0, 4);
       // + "."
    }

    // return MainUtils.colorFormatter(value, color);
    return value;
  }

  static colorFormatter(value, color) {
    let size = "8";
    if (window.innerWidth > 1000) {
      size = 16;
    }

    let imgSrc = "/images/" + color + "-" + size + ".png"
    return (<span><img src={imgSrc} /> {value}</span>)
  }


  static colorFormatterOnly(value, color) {
    let size = "8";

    let imgSrc = "/images/" + color + "-" + size + ".png"
    return (<span><img src={imgSrc} /></span>)
  }


  static getHPoolId(thisObj) {
    var poolId = thisObj.props.match.params.poolId;
    // if (poolId === undefined) {
    //   poolId = con fig.api Gate way.DEFAULT _POOL_ID;
    // }

    return poolId;
  }

  static coinCountCellFormatter(cell, row) {
    // console.log(typeof cell);
    if (!cell) {
      return cell;
    }

    return SPCalc.formatCoinCount(cell.toFixed(0));
  }

  static blsKeyCountFormatter(cell, row) {
    if (row.status === constants.notEligibleStatus || row.optimalBlsKeyCount === 0) {
      return cell;
    }
    // console.log(cell, row);
    let color = "green";

    if (row.blsKeyCount > cell) {
      // return <span style={{backgroundColor: "#f5b514"}}>{cell}</span>;
      color = "red";
    } else if (row.blsKeyCount < cell) {
      // return <span style={{backgroundColor: "#f5b514"}}>{cell}</span>;
      color = "orange";
    }

    return MainUtils.colorFormatter(cell, color);
  }

  static convertPercentFormatter(cell, row) {
    if (!cell) {
      if (cell === 0) {
        return (window.innerWidth > constants.MEDIUM) ? "0%" : "0";
      }
      return cell;
    }

    let value = cell
    if (cell > 0) {
      var formattedNumber = (cell * 100).toFixed(2).replace(/[.,]00$/, "");
      value = formattedNumber;
      // let percentVal = cell * 100;
      // return (percentVal.toFixed(2) + "%");
    }

    if (window.innerWidth > constants.MEDIUM) {
      return value + "%";
    }

    return value
  }

  static percentFormatter(cell, row) {
    return MainUtils.percentFormatterDecimal(cell, 2);
  }

  static percentFormatterSingle(cell, row) {
    return MainUtils.percentFormatterDecimal(cell, 1);
  }

  static percentFormatterDecimal(cell, decimalPlaces) {
    if (!cell) {
      if (cell === 0) {
        return <span align="right">0%</span>;
      }
      return cell;
    }

    let value = cell;
    if (cell > 0) {
      // console.log((typeof cell), " - in percentFormatter: ", cell);
      var formattedNumber = (cell).toFixed(decimalPlaces).replace(/[.,]00$/, "");
      value = formattedNumber;
    }

    return value + "%";
  }

  static formatBigCoinCount(count) {
    if (window.innerWidth < constants.MEDIUM) {
      return SPUtilities.stakeFormatterRounded(count);
    } else {
      return SPCalc.formatCoinCount(count);
    }
  }

  static logoFormatter(cell, row) {
    let url = "images/logo/" + row.address + ".jpg";
    return MainUtils.logoFormatterFlex(url, false);
  }

  static logoFormatterFlex(logoPath, large) {
    // console.log(logoPath)
    if (!logoPath) {
      return logoPath;
    }

    let size = 16;

    if (large && window.innerWidth < 1000) {
      size = 32;
    } else if (large) {
      size = 32;
    } else if (window.innerWidth > 1000) {
      size=20;
    }

    return "";
  }

  static showCurrentReturns(value, row) {
    if (row.status === 'Elected' && !value) {
      return "N/A";
    }

    return value;
  }

  static lifetimeSignPer(cell, row) {
    return MainUtils.calcPercent(cell, row.lifetimeToSign)
  }

  static getSupportUs() {
    return "";
  }

  static getCommission(cell, row, index) {
    // console.log(row);
    if (row.commIncreaseTime !== null) {
      return (<span style={{"backgroundColor": "orange", "padding": "0.2rem"}}>{row.commIncreaseDesc}</span>);
    }

    return cell + "%";
  }

  static renderEventTypes(thisObj) {
    if (RespUtils.isMobileView()) {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId}>All</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/Delegate"}>Del</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/Undelegate"}>Undel</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/val"}>Val</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/fee"}>Fee &#x00B1;</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/large"}>Large</a></td>
        </tr></tbody></table></div>);
    } else {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId}>All</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/Delegate"}>Delegate</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/Undelegate"}>Undelegate</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/val"}>Validator Changes</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/fee"}>Fee Changes</a></td>
          <td className="view-tag"><a className="white-a" href={"/events/" + thisObj.state.val.poolId + "/large"}>Large</a></td>
        </tr></tbody></table></div>);
    }
  }

  static getSmartStakeMsg(smartStakeInd) {
    // console.log("this.props.smartStake : ", this.props.smartStake);
    if (smartStakeInd !== null && smartStakeInd === false) {
      return (MainUtils.getSupportUs())
    }

    return "";
  }

  static formatEventType(cell) {
    if (!cell || !RespUtils.isMobileView()) {
      return cell;
    }

    if (cell === 'CollectRewards') {
      return "Rewards";
    } else if (cell === 'EditValidator') {
      return "EditVal";
    } else if (cell === 'Undelegate') {
      return "Undel";
    } else if (cell === 'Delegate') {
      return "Del";
    }

    return cell;
  }


  static convert2DigitsDecimal(cell, row) {
    if (!cell) {
      return cell;
    }

    let value = cell
    if (cell > 0) {
      value = (cell).toFixed(2).replace(/[.,]00$/, "");
    }

    return value
  }

  static stakeFormatter(cell, row, index, extra) {
    return <StakeFormatter name={row.name} address={row.operatorAddress}
      label="Delegate" isSS="false" />
  }

  static stakeFormatterLarge(address) {
    return "";
  }

  static renderRewards() {
    if (RespUtils.isTabletView()) {
      return (<p><a href="/account" className="black-a">Rewards dashboard</a></p>);
    }

    return "";
  }

  static consensusStyleFormatter(cell, row, index, extra) {
    if (!cell) return "";
    if (row.status === 'NotEligible') {
      return {"background-image": "linear-gradient(to right, rgb(245, 167, 30), #ffffff)"};
    } else if (row.status === 'Elected') {
      return {"background-image": "linear-gradient(to right, #00b4a0, #ffffff)"};
    } else {
      return {"background-image": "linear-gradient(to right, #00b4a0, #ffffff)"};
    }
  }

  static slotFormatter(cell, row, index, extra) {
    if (!cell) return "";

    return row.slot;
  }

  static intFormatter(cell, row) {
    if (!cell) return "";

    return parseInt(cell);
  }

  static calcRewardRatio(cell, row, index, extra) {
    if (!cell) return "";

    // console.log("getRewardRatio(row.stake: ", row.stake, ", row.reward: ", row.reward, ", extra: ", extra);
    return MainUtils.getRewardRatio(row.stake, row.reward, extra);
  }

  static getRewardRatio(stake, reward, totals) {
    if (stake === undefined || stake === 0) {
      // console.log("1");
      return "";
    } else if (reward === undefined || reward === 0) {
      // console.log("2");
      return 0;
    }

    if (totals.stake === 0 || totals.reward === 0) {
        // console.log("3");
        return "";
    }

    let percentStake = stake * 100 /totals.stake;
    let percentReward = reward * 100 /totals.reward;
    // console.log("percentStake: ", percentStake, ", percentReward: ", percentReward);

    if (percentReward === "" || percentReward === 0) {
      // console.log("4");
      return 0;
    }

    return numeral(percentReward/percentStake).format('0.00a');
  }

  static blsKeyFormatter(cell, row) {
    return MainUtils.blsKeyFormatterBySize(cell, row, true);
  }

  static blsKeyFormatterLarge(key, row) {
    return MainUtils.blsKeyFormatterBySize(key, row, RespUtils.isTabletView());
  }

  static blsKeyFormatterBySize(key, row, short) {
    if (!key) {
      return "";
    }

    let label = SPUtilities.addressLabelShortFormatter(key, null, short);
    let link = "/key/";
    let target = "";

    return (<span><a className="black-a" target={target}
      href={link + key + "/" + row.epochNumber}>{label}</a></span>);
  }

  static getBreadCrumb() {
    return "";
  }

  static getShortText(text, length, alwaysShort) {
    if (RespUtils.isNotTabletView()) {
      if (!alwaysShort && alwaysShort === false) {
        return text;
      }
    }

    if (!text) {
      return "";
    }

    let label = text.split("?").join("");

    if (label.length > length) {
      label = label.substring(0, length - 2) + "..";
    }

    return label;
  }

  static getAddress(cell) {
    return (
      <React.Fragment>
        {MainUtils.getShortText(cell, 20)}
        {AddressUtils.copyLink(cell)}
      </React.Fragment>
      );
  }

  static getAddressLong(cell) {
    let length = RespUtils.isMobileView() ? 20 : 50;
    return (
      <React.Fragment>
        {MainUtils.getShortText(cell, length)}
        {AddressUtils.copyLink(cell)}
      </React.Fragment>
      );
  }

  static getBadges(cell, row) {
    // console.log(row)

    return <React.Fragment>
      {row.ibcRelayerInd === 'true' && MainUtils.getIBCRelayerLogo("medium")}
    </React.Fragment>;
  }

  static getIBCRelayerLogo(size) {
    let logoSize = size ? size : "large";
    return (<span title="Validator runs IBC Relayer" className="valBadge"> 
        <CompareArrowsIcon className="mInfoIcon" style={{fill: "white"}} fontSize={logoSize} />
      </span>)
  }

  static renderNewValidatorBadge(validator) {
    if (constants.app.enableIsNew === true && validator.isNew === "true") {
      return (<span className="cloud">New</span>);
    }

    return "";
  }

  static convertListToMap(listObj, attributeName) {
    var result = listObj.reduce(function(map, obj) {
        let attr = obj[attributeName];
        map[attr] = obj;
        return map;
    }, {});
    
    return result;
  }

  static formatBadges(cell, row) { 
    return MainUtils.formatBadgesLarge(row, false);
  }

  static formatBadgesLarge(row, largeInd) {
    let relayer = (constants.ui.badges.relayer === true && row.ibcRelayerInd === "true");
    let restakeInd = (constants.ui.badges.restake === true && row.restake === "true");
    let restakeLink = "https://restake.app/" + constants.ui.badges.restakeApp + "/" + row.operatorAddress;
    let foundationNodeInd = (constants.ui.badges.foundationNodeInd === true && row.foundationNodeInd === "true");

    let badge1Ind = (constants.ui.badges.badge1Ind === true && row.badge1Ind === "true");
    let badge2Ind = (constants.ui.badges.badge2Ind === true && row.badge2Ind === "true");
    let yieldmosInd = (constants.ui.badges.yieldmosInd === true);

    let size = largeInd ? "large" : "small";
    // console.log(constants.ui.badges.badge2IndImg);
    return (
        <div>
            {MainUtils.renderImage(restakeInd, "/images/restake.png", restakeLink, "Validator supports restake.app for auto compounding. Click to use restake.app", largeInd)}
            {relayer && <span title="Validator runs IBC Relayer service" className="valBadge"> 
              <CompareArrowsIcon className="mInfoIcon" style={{fill: "white"}} fontSize={size}/>
            </span>}
            {MainUtils.renderImage(foundationNodeInd, constants.app.defaultLogo, null, constants.ui.badges.foundationNodeIndLabel, largeInd)}
            {MainUtils.renderImage(badge1Ind, constants.ui.badges.badge1IndImg, constants.ui.badges.badge1IndLink, 
              constants.ui.badges.badge1IndLabel, largeInd)}
            {MainUtils.renderImage(badge2Ind, constants.ui.badges.badge2IndImg, constants.ui.badges.badge2IndLink, 
              constants.ui.badges.badge2IndLabel, largeInd)}
            {MainUtils.renderImage(yieldmosInd, "/images/yieldmos.png", "https://www.yieldmos.com/", 
              "Yieldmos supports auto compounding for all validators of the network", largeInd)}
            
        </div>
    );
  }

  static renderImage(condition, imgSrc, imgLink, imgTitle, large) {
    let size = large ? "32px" : "24px";
    // valBadge mediaCustomImg
    if (condition) {
      if (imgLink) {
        return (<a href={imgLink} target="_blank" title={imgTitle} className="mediaCustom">
                <img className="valBadgeBorder" width={size} height={size} src={imgSrc} />&nbsp;
               </a>);
      } else {
        return (<span title={imgTitle} className="mediaCustom">
                <img className="valBadgeBorder" width={size} height={size} src={imgSrc} />&nbsp;
               </span>);
      }
    }

    return "";
  }
}

export default MainUtils;
